import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#alert" }),
    /*#__PURE__*/_createTextVNode(" Alert ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Displays important alert messages. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUITheme = _resolveComponent("EUITheme")
  const _component_EUICustomizableCloseButton = _resolveComponent("EUICustomizableCloseButton")
  const _component_EUIWithIcon = _resolveComponent("EUIWithIcon")
  const _component_EUICenteredText = _resolveComponent("EUICenteredText")
  const _component_EUIWithDescription = _resolveComponent("EUIWithDescription")
  const _component_EUIWithIconAndDescription = _resolveComponent("EUIWithIconAndDescription")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUITheme),
    _createVNode(_component_EUICustomizableCloseButton),
    _createVNode(_component_EUIWithIcon),
    _createVNode(_component_EUICenteredText),
    _createVNode(_component_EUIWithDescription),
    _createVNode(_component_EUIWithIconAndDescription)
  ], 64))
}